module.exports = __webpack_public_path__ + "img/link_icon.4ac4322a.svg";